import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';
import { inWhitelabel } from 'core/whitelabel';
import { Link } from 'core/routing';

import { Divisor, Button, Box } from 'components';

import { MobileNavViewport, ListWrapper } from './mobileUserNav.styled';

const MobileMainNav = props => {
  const { show } = props;

  useEffect(() => {
    document.querySelector('html').style.overflowY = show
      ? 'hidden'
      : 'initial';
  }, [show]);

  return (
    <MobileNavViewport show={show}>
      {!inWhitelabel() &&
        (props.isLogged ? null : (
          <Box
            px={4}
            py={3}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Button
                appearance='plain'
                text={<Trans>Log in</Trans>}
                onClick={props.onClickSignIn}
              />
              <Divisor variant='vertical' />
              <Button
                appearance='plain'
                text={<Trans>Sign up</Trans>}
                onClick={props.onClickSignUp}
              />
            </Box>
            <Link name='make-part'>
              <Button size='small' text={<Trans>Get a Quote</Trans>} />
            </Link>
          </Box>
        ))}
      <Divisor />
      <ListWrapper show={show}>
        {props.mainNav}
        {props.search}
      </ListWrapper>
    </MobileNavViewport>
  );
};

MobileMainNav.defaultProps = {
  show: false,
  isLogged: false,
  mainNav: null,
  search: null,
};

MobileMainNav.propTypes = {
  show: PropTypes.bool,
  isLogged: PropTypes.bool,
  mainNav: PropTypes.node,
  search: PropTypes.node,
  routeName: PropTypes.string,
  onClickSignIn: PropTypes.func,
  onClickSignUp: PropTypes.func,
};

export default withNamespaces()(MobileMainNav);
